import NAME from "./constants";

export const RESET_ALL = NAME + "/RESET_ALL";

export const GET_ALL_MY_TRAINING = NAME + "/GET_ALL_MY_TRAINING";
export const GET_ALL_MY_TRAINING_REJECTED = NAME + "/GET_ALL_MY_TRAINING_REJECTED";
export const GET_ALL_MY_TRAINING_FULFILLED = NAME + "/GET_ALL_MY_TRAINING_FULFILLED";

export const GET_SPECIFIC_TRAINING_PROGRESS = NAME + "/GET_SPECIFIC_TRAINING_PROGRESS";
export const GET_SPECIFIC_TRAINING_PROGRESS_REJECTED = NAME + "/GET_SPECIFIC_TRAINING_PROGRESS_REJECTED";
export const GET_SPECIFIC_TRAINING_PROGRESS_FULFILLED = NAME + "/GET_SPECIFIC_TRAINING_PROGRESS_FULFILLED";

export const DOWNLOAD_MY_TRAINING_CERTIFICATES = NAME + "/DOWNLOAD_MY_TRAINING_CERTIFICATES";
export const DOWNLOAD_MY_TRAINING_CERTIFICATES_REJECTED = NAME + "/DOWNLOAD_MY_TRAINING_CERTIFICATES_REJECTED";
export const DOWNLOAD_MY_TRAINING_CERTIFICATES_FULFILLED = NAME + "/DOWNLOAD_MY_TRAINING_CERTIFICATES_FULFILLED";

// execution
export const GET_SPECIFIC_TRAINING = NAME + "/GET_SPECIFIC_TRAINING";
export const GET_SPECIFIC_TRAINING_REJECTED = NAME + "/GET_SPECIFIC_TRAINING_REJECTED";
export const GET_SPECIFIC_TRAINING_FULFILLED = NAME + "/GET_SPECIFIC_TRAINING_FULFILLED";
export const RESET_SPECIFIC_TRAINING = NAME + "/RESET_SPECIFIC_TRAINING";

export const GET_ACTIVITY = NAME + "/GET_ACTIVITY";
export const GET_ACTIVITY_REJECTED = NAME + "/GET_ACTIVITY_REJECTED";
export const GET_ACTIVITY_FULFILLED = NAME + "/GET_ACTIVITY_FULFILLED";

export const START_ACTIVITY = NAME + "/START_ACTIVITY";
export const START_ACTIVITY_REJECTED = NAME + "/START_ACTIVITY_REJECTED";
export const START_ACTIVITY_FULFILLED = NAME + "/START_ACTIVITY_FULFILLED";

export const GET_COUNTDOWN_ACTIVITY = NAME + "/GET_COUNTDOWN_ACTIVITY";
export const GET_COUNTDOWN_ACTIVITY_REJECTED = NAME + "/GET_COUNTDOWN_ACTIVITY_REJECTED";
export const GET_COUNTDOWN_ACTIVITY_FULFILLED = NAME + "/GET_COUNTDOWN_ACTIVITY_FULFILLED";

export const ANSWER_ACTIVITY = NAME + "/ANSWER_ACTIVITY";
export const ANSWER_ACTIVITY_REJECTED = NAME + "/ANSWER_ACTIVITY_REJECTED";
export const ANSWER_ACTIVITY_FULFILLED = NAME + "/ANSWER_ACTIVITY_FULFILLED";

export const GET_RESOLUTION = NAME + "/GET_RESOLUTION";
export const GET_RESOLUTION_REJECTED = NAME + "/GET_RESOLUTION_REJECTED";
export const GET_RESOLUTION_FULFILLED = NAME + "/GET_RESOLUTION_FULFILLED";

export const GRADE_ACTIVITY = NAME + "/GRADE_ACTIVITY";
export const GRADE_ACTIVITY_REJECTED = NAME + "/GRADE_ACTIVITY_REJECTED";
export const GRADE_ACTIVITY_FULFILLED = NAME + "/GRADE_ACTIVITY_FULFILLED";

export const UPDATE_ACTIVITY_ATTEMPT = NAME + "/UPDATE_ACTIVITY_ATTEMPT";
export const UPDATE_ACTIVITY_ATTEMPT_REJECTED = NAME + "/UPDATE_ACTIVITY_ATTEMPT_REJECTED";
export const UPDATE_ACTIVITY_ATTEMPT_FULFILLED = NAME + "/UPDATE_ACTIVITY_ATTEMPT_FULFILLED";

// Q&A
export const VOTE_QUESTION = NAME + "/VOTE_QUESTION";
export const VOTE_QUESTION_REJECTED = NAME + "/VOTE_QUESTION_REJECTED";
export const VOTE_QUESTION_FULFILLED = NAME + "/VOTE_QUESTION_FULFILLED";

export const CLOSE_QUESTION = NAME + "/CLOSE_QUESTION";
export const CLOSE_QUESTION_REJECTED = NAME + "/CLOSE_QUESTION_REJECTED";
export const CLOSE_QUESTION_FULFILLED = NAME + "/CLOSE_QUESTION_FULFILLED";

export const GET_QUESTION_AND_ANSWERS = NAME + "/GET_QUESTION_AND_ANSWERS";
export const GET_QUESTION_AND_ANSWERS_REJECTED = NAME + "/GET_QUESTION_AND_ANSWERS_REJECTED";
export const GET_QUESTION_AND_ANSWERS_FULFILLED = NAME + "/GET_QUESTION_AND_ANSWERS_FULFILLED";

export const CREATE_QUESTION = NAME + "/CREATE_QUESTION";
export const CREATE_QUESTION_REJECTED = NAME + "/CREATE_QUESTION_REJECTED";
export const CREATE_QUESTION_FULFILLED = NAME + "/CREATE_QUESTION_FULFILLED";

export const UPDATE_QUESTION = NAME + "/UPDATE_QUESTION";
export const UPDATE_QUESTION_REJECTED = NAME + "/UPDATE_QUESTION_REJECTED";
export const UPDATE_QUESTION_FULFILLED = NAME + "/UPDATE_QUESTION_FULFILLED";

export const DELETE_QUESTION = NAME + "/DELETE_QUESTION";
export const DELETE_QUESTION_REJECTED = NAME + "/DELETE_QUESTION_REJECTED";
export const DELETE_QUESTION_FULFILLED = NAME + "/DELETE_QUESTION_FULFILLED";

export const CREATE_ANSWER = NAME + "/CREATE_ANSWER";
export const CREATE_ANSWER_REJECTED = NAME + "/CREATE_ANSWER_REJECTED";
export const CREATE_ANSWER_FULFILLED = NAME + "/CREATE_ANSWER_FULFILLED";

export const UPDATE_ANSWER = NAME + "/UPDATE_ANSWER";
export const UPDATE_ANSWER_REJECTED = NAME + "/UPDATE_ANSWER_REJECTED";
export const UPDATE_ANSWER_FULFILLED = NAME + "/UPDATE_ANSWER_FULFILLED";

export const DELETE_ANSWER = NAME + "/DELETE_ANSWER";
export const DELETE_ANSWER_REJECTED = NAME + "/DELETE_ANSWER_REJECTED";
export const DELETE_ANSWER_FULFILLED = NAME + "/DELETE_ANSWER_FULFILLED";

// notes
export const UPDATE_NOTE = NAME + "/UPDATE_NOTE";
export const UPDATE_NOTE_REJECTED = NAME + "/UPDATE_NOTE_REJECTED";
export const UPDATE_NOTE_FULFILLED = NAME + "/UPDATE_NOTE_FULFILLED";

// stats
export const GET_STATS = NAME + "/GET_STATS";
export const GET_STATS_REJECTED = NAME + "/GET_STATS_REJECTED";
export const GET_STATS_FULFILLED = NAME + "/GET_STATS_FULFILLED";

export const GET_STATS_BY_TRAINING = NAME + "/GET_STATS_BY_TRAINING";
export const GET_STATS_BY_TRAINING_REJECTED = NAME + "/GET_STATS_BY_TRAINING_REJECTED";
export const GET_STATS_BY_TRAINING_FULFILLED = NAME + "/GET_STATS_BY_TRAINING_FULFILLED";